
<a href="javascript:void(0)" id="back-to-top" (click)="taptotop()" [ngStyle]="{ 'display' : show ? 'block' : 'none' }"><i class="fa fa-angle-up"></i></a>